import { marker as extractTranslation } from '@colsen1991/ngx-translate-extract-marker';
import { ScreeningAdverseMediaEntity } from '@nk/data-entities-lib';
import { NkPagination } from '@nk/ui-lib';
import { removeCompanyNameAbbreviationsAndStopWords } from '@nk/utils-lib';

export interface ScreeningAdverseMediaCardListItem {
  uuid: string;
  matchName: string;
  matchScore: number;
  title: string;
  snippet: string;
  publishingDate: Date | null;
  url: string;
  highlightTexts: string[];
}

export interface ScreeningAdverseMediaCardListData {
  entities: ScreeningAdverseMediaCardListItem[];
  pagination: NkPagination;
}

export const SCREENING_ADVERSE_MEDIA_TRANSLATIONS = {
  header: extractTranslation('tables.screening_adverse_media.header'),
  noDataFound: extractTranslation('tables.screening_adverse_media.no_data_found'),
};

export const EMPTY_SCREENING_ADVERSE_MEDIA_CARD_LIST_DATA: ScreeningAdverseMediaCardListData = {
  entities: [],
  pagination: { limit: 0, page: 0, totalCount: 0 },
};

export function getAdverseMediaHighlightTexts(names: (string | undefined | null)[]): string[] {
  return names
    .filter((name): name is string => !!name)
    .map((name) => removeCompanyNameAbbreviationsAndStopWords(name))
    .flatMap((name) => name.split(/\s+/))
    .filter(Boolean);
}

export function transformToScreeningAdverseMediaCardListItems(
  entities: ScreeningAdverseMediaEntity[],
): ScreeningAdverseMediaCardListItem[] {
  return entities.map((entity) => {
    const publishingDate = entity.publishing_date ? new Date(entity.publishing_date) : null;

    return {
      uuid: entity.uuid || entity.screening_entity_uuid,
      matchName: entity.match_name,
      matchScore: entity.match_score,
      title: entity.title || '-',
      snippet: entity.snippet || '-',
      publishingDate,
      url: entity.url || '-',
      highlightTexts: getAdverseMediaHighlightTexts([entity.match_name]),
    };
  });
}
